import React from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import { purifier } from '../../utils/dom';
import { getYear } from '../../utils/date';
import { translate, prefix } from '../../utils/locale';
import s from './Footer.scss';

const Footer = ({ footer, general, setup, properties, location }) => {
	if (properties.siteInitiated === false || properties.siteClosed === true) return null;

	return (
		<div className={s.footer}>
			<div className={s.footer_about} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, footer.about).replace('%year%', getYear())) }} />
			<Link className={s.footer_index} to={location === 'INDEXES' ? prefix(setup, '/') : prefix(setup, '/index')} style={{ backgroundColor: general.backgroundColor }}>{ location === 'INDEXES' ? translate(setup, footer.close) : translate(setup, footer.index) }</Link>
		</div>
	);
};

const mapState = ({ environment, location }) => {
	const { properties, setup, footer, general } = environment;
	return { properties, setup, footer, general, location: location.type };
};

export default connect(mapState)(Footer);
